import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";

const Header = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("role");
    localStorage.removeItem("permissions");
    setShowDropdown(false);
    window.location.href = "/"; // Force redirect to trigger App.js check
  };

  return (
    <header className="admin-header">
      <div className="header-brand">
        <img src={logo} alt="College Logo" className="header-logo" />
      </div>
      <div className="header-titles">
        <h1>Rajat Group Of College</h1>
        <p className="subtitle">Permanently Associated with Lucknow University, Lucknow & N.C.T.E.</p>
        <p className="details-line">College under Section 2(f) & 12(B) • Recognised by UGC Act, 1956 by Govt. of India</p>
        <p className="accreditation">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#d97706" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
          Accredited &lsquo;A&rsquo; Grade by NAAC
        </p>
      </div>
      <div className="admin-header__right" ref={dropdownRef}>
        <div className="admin-avatar" onClick={() => setShowDropdown(!showDropdown)}>A</div>
        {showDropdown && (
          <div className="avatar-dropdown">
            <button onClick={handleLogout} className="logout-btn">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
